"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = {
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    datePicker: {
        root: {
            maxWidth: '200px',
            marginRight: '30px'
        }
    },
    submitButton: {
        root: {
            maxWidth: '180px'
        }
    },
    loadingTextNote: {
        root: {
            opacity: 0.4,
            textAlign: 'center',
            marginTop: '20px'
        }
    }
};
